import { render } from "./CollectionGrid.vue?vue&type=template&id=18866f44"
import script from "./CollectionGrid.vue?vue&type=script&lang=js"
export * from "./CollectionGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__